import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import { FormControl, InputLabel, Menu, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  transactionTypeDetailInvoice,
  transactionTypeDetailOther,
  transactionTypeDetailPurchaseOrder,
  transactionTypeDetailSalesOrder,
  transactionTypeDetailBill,
  transactionTypeCreditMemo,
  transactionJournalTable,
  transactionDepositTable,
  transactionRevenueArrangementTable,
  transactionTypeCustom,
  transactionTypeBillPayment,
  globalSearch,
} from "../../config/grid-column-defs";
import {
  getTransactionTypeDetail,
  getTransactionTypeDetailExcelData,
  getTransactionTypesap_check,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Box, Grid, Typography, Button, Paper, TextField } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isAfter, isToday } from "date-fns";
import { saveAs } from "file-saver";
import AgGridPaginatedPageNumberSearchTable from "../../components/AgGridPaginatedPageNumberSearchTable";
import { getSubsidiary } from "../../api/accounts";
import { baseUrl } from "../../config/api-config";
import { getUser } from "../../actions/auth";

export default function GlobalSearch() {
  const [anchorEl, setAnchorEl] = useState(null);
  const dateRef = useRef();
  const MemoRef = useRef();
  const docuRef = useRef();
  const customerRef = useRef();
  const subsidiaryRef = useRef();
  const poCheckNumberRef = useRef();
  const vendorRef = useRef();
  const currencyRef = useRef();
  const accountRef = useRef();
  const postingRef = useRef();
  const [dateSortAscending, setDateSortAscending] = useState(true);
  const [dateChecked, setDateChecked] = useState(false);
  const [MemoChecked, setMemoChecked] = useState(false);
  const [docuChecked, setdocuChecked] = useState(false);
  const [idChecked, setidChecked] = useState(false);
  const [customerChecked, setCustomerChecked] = useState(false);
  const [subsidiaryChecked, setSubsidiaryChecked] = useState(false);
  const [poCheckNumberChecked, setPoCheckNumberChecked] = useState(false);
  const [vendorChecked, setVendorChecked] = useState(false);
  const [currencyChecked, setCurrencyChecked] = useState(false);
  const [accountChecked, setAccountChecked] = useState(false);
  const [postingChecked, setPostingChecked] = useState(false);
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [onInputSearch, setInputSearch] = useState({});
  const [searchInputValue, setSearchValue] = useState("");
  const [date_For_validation, setDate_validation] = useState({});
  const params = useParams();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("search");
  //console.log(params.slug);
  const pageDetail = slugMap[params.slug] ? slugMap[params.slug] : params.slug;
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [totalSum, setTotalSum] = useState("");
  // date //
  const today = new Date();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [documentNoSearchInputValue, setDocumentNoSearchValue] = useState("");
  const [memoSearchInputValue, setMemoSearchValue] = useState("");
  const [viewIdSearchInputValue, setViewIdSearchInputValue] = useState("");
  const [customerSearchInputValue, setCustomerSearchInputValue] = useState("");
  const [subsidiarySearchInputValue, setSubsidiarySearchInputValue] =
    useState("");
  const [poCheckNumberSearchInputValue, setPoCheckNumberSearchInputValue] =
    useState("");
  const [vendorSearchInputValue, setVendorSearchInputValue] = useState("");
  const [currencySearchInputValue, setCurrencySearchInputValue] = useState("");
  const [accountSearchInputValue, setAccountSearchInputValue] = useState("");
  const [postingSearchInputValue, setPostingSearchInputValue] = useState("");
  const [subsdiaryRowData, setSubsidiaryRowData] = useState([]);
  const dispatch =useDispatch();
  // date  //

  const [error, setError] = useState("");
  const open1 = Boolean(anchorEl);
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };
const [exportLoading, setExportLoading] = useState(false);

  useEffect(()=>{
    const token = localStorage.getItem("token");
    if (token) {
      // console.log("Token but not logged in");
      dispatch(getUser(token));
    }
  },[])

  async function getTransactionTypeDetailTableData(limit, offset) {
    try {

        const response = await fetch(
        `${baseUrl}/getGlobalSearch?limit=${limit}&offset=${offset}&search_text=${query}`,
        {
          headers: {
            authorization: user.token,
          },
        }
      );
      const data = await response.json();
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  const exportData = async () => {
    setExportLoading(true);
  
    try {
      const response = await fetch(
        `${baseUrl}/getGlobalSearch?limit=${""}&offset=${""}&search_text=${query}&file=xlsx`,
        {
          headers: {
            authorization: user.token,
               responseType:"blob"
          },
        }
      );
      const blob = await response.blob();
      const filename = `Global Search_${format(today, "MM/dd/yyyy")}.csv`;
      saveAs(blob, filename);
    } catch (error) {
      setExportLoading(false);
      snackbar.showError("File does not exist");
    } finally {
      setExportLoading(false);
    }
  };
  
 
//   const onDocumentNoInputSearch = (event) => {
//     setDocumentNoSearchValue(event.target.value);
//     setInputSearch({ ...onInputSearch, documentno: event.target.value });
//   };
//   const onMemoInputSearch = (event) => {
//     setMemoSearchValue(event.target.value);
//     setInputSearch({ ...onInputSearch, memo: event.target.value });
//   };
//   const onViewIdInputSearch = (event) => {
//     setViewIdSearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, internalid: event.target.value });
//   };
//   const onCustomerInputSearch = (event) => {
//     setCustomerSearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, name: event.target.value });
//   };
//   const onSubsidiaryInputSearch = (event) => {
//     setSubsidiarySearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, subsidiary_name: event.target.value });
//   };
//   const onPoCheckNumberInputSearch = (event) => {
//     setPoCheckNumberSearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, po_check_number: event.target.value });
//   };
//   const onVendorInputSearch = (event) => {
//     setVendorSearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, name: event.target.value });
//   };
//   const onCurrencyInputSearch = (event) => {
//     setCurrencySearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, currency: event.target.value });
//   };
//   const onAccountInputSearch = (event) => {
//     setAccountSearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, account: event.target.value });
//   };
//   const onPostingInputSearch = (event) => {
//     setPostingSearchInputValue(event.target.value);
//     setInputSearch({ ...onInputSearch, posting: event.target.value });
//   };
//   const handleClose1 = (event) => {
//     if (event.target.name === "memo") {
//       setMemoChecked(event.target.checked);
//       setMemoSearchValue("");
//       setInputSearch({ ...onInputSearch, memo: "" });
//     }
//     if (event.target.name === "date") {
//       setDateChecked(event.target.checked);
//       setStartDate("");
//       setEndDate("");
//       setInputSearch({ ...onInputSearch, datefrom: "", dateto: "" });
//     }
//     if (event.target.name === "documentno") {
//       setdocuChecked(event.target.checked);
//       setDocumentNoSearchValue("");
//       setInputSearch({ ...onInputSearch, documentno: "" });
//     }
//     if (event.target.name === "internalid") {
//       setidChecked(event.target.checked);
//       setViewIdSearchInputValue("");
//       setInputSearch({ ...onInputSearch, internalid: "" });
//     }
//     if (event.target.name === "name") {
//       setCustomerChecked(event.target.checked);
//       setCustomerSearchInputValue("");
//       setInputSearch({ ...onInputSearch, name: "" });
//     }
//     if (event.target.name === "subsidiary_name") {
//       setSubsidiaryChecked(event.target.checked);
//       setSubsidiarySearchInputValue("");
//       setInputSearch({ ...onInputSearch, subsidiary_name: "" });
//     }
//     if (event.target.name === "po_check_number") {
//       setPoCheckNumberChecked(event.target.checked);
//       setPoCheckNumberSearchInputValue("");
//       setInputSearch({ ...onInputSearch, po_check_number: "" });
//     }
//     if (event.target.name === "vendor") {
//       setVendorChecked(event.target.checked);
//       setVendorSearchInputValue("");
//       setInputSearch({ ...onInputSearch, name: "" });
//     }
//     if (event.target.name === "currency") {
//       setCurrencyChecked(event.target.checked);
//       setCurrencySearchInputValue("");
//       setInputSearch({ ...onInputSearch, currency: "" });
//     }
//     if (event.target.name === "account") {
//       setAccountChecked(event.target.checked);
//       setAccountSearchInputValue("");
//       setInputSearch({ ...onInputSearch, account: "" });
//     }
//     if (event.target.name === "posting") {
//       setPostingChecked(event.target.checked);
//       setPostingSearchInputValue("");
//       setInputSearch({ ...onInputSearch, posting: "" });
//     }

//     setAnchorEl(null);
//   };

//   function refreshTable() {
//     setTableRefreshCount((prev) => prev + 1);
//   }
//   useEffect(() => {
//     setInputSearch({});
//     setSearchValue("");
//     handleClickReset();
//   }, [params.slug]);

//   const handleClickReset = (event) => {
//     setInputSearch({});
//     setSearchValue("");
//     setStartDate("");
//     setEndDate("");
//     setAnchorEl(null);
//     setDateChecked(dateChecked ? false : false);
//     setMemoChecked(MemoChecked ? false : false);
//     setdocuChecked(false);
//     setidChecked(false);
//     setCustomerChecked(false);
//     setSubsidiaryChecked(false);
//     setPoCheckNumberChecked(false);
//     setVendorChecked(false);
//     setCurrencyChecked(false);
//     setAccountChecked(false);
//     setPostingChecked(false);
//   };

//   function onSortChanged() {
//     setDateSortAscending((previous) => !previous);
//     setTableRefreshCount((prev) => prev + 1);
//   }

//   function isStringInteger(value) {
//     return (
//       Number.isInteger(parseInt(value)) && value === parseInt(value).toString()
//     );
//   }

//   const InputSearch = (event) => {
//     if (isStringInteger(event.target.value) || docuChecked) {
//       setInputSearch({ ...onInputSearch, documentno: event.target.value });
//       setSearchValue(event.target.value);
//     } else if (event.target.value.includes("/")) {
//       setInputSearch({ ...onInputSearch, datefrom: event.target.value });
//     } else if (MemoChecked) {
//       setInputSearch({ ...onInputSearch, memo: event.target.value });
//     }
//     if (
//       !MemoChecked &&
//       !docuChecked &&
//       !idChecked &&
//       !dateChecked &&
//       !subsidiaryChecked &&
//       !poCheckNumberChecked &&
//       !vendorChecked &&
//       !currencyChecked &&
//       !accountChecked &&
//       !postingChecked
//     ) {
//       setInputSearch({ ...onInputSearch, documentno: event.target.value });
//       setSearchValue(event.target.value);
//     }

//     if (!event.target.value.includes("-")) {
//       setSearchValue(event.target.value);
//     }
//   };

//   const handleStartDateChange = (date) => {
//     if (isAfter(date, today)) {
//       // If the selected start date is after today, do not update the state
//       return;
//     }
//     setStartDate(date);
//     setInputSearch({
//       ...onInputSearch,

//       datefrom: format(date, "MM/dd/yyyy"),
//     });
//     // Ensure that the selected start date is always older than the end date
//     if (endDate && isAfter(date, endDate)) {
//       setEndDate(null);
//     }
//   };

//   const handleEndDateChange = (date) => {
//     if (isAfter(date, today)) {
//       // If the selected end date is after today, do not update the state
//       return;
//     }

//     // Ensure that the selected end date is always after the start date
//     if (startDate && isAfter(startDate, date)) {
//       return;
//     }
//     setInputSearch({
//       ...onInputSearch,

//       dateto: format(date, "MM/dd/yyyy"),
//     });
//     setEndDate(date);
//   };
 
//   useEffect(() => {
//     if (user.token) {
//       getSubsidiaryData();
//     }
//   }, [user.token]);
//   async function getSubsidiaryData() {
//     try {
//       const { data } = await getSubsidiary(user.token, {});
//       setSubsidiaryRowData(data?.data);
//     } catch (error) {
//       console.log(error);
//       snackbar.showError("Error In Loading Data.");
//     } finally {
//       // setLoading(false)
//     }
//   }


  const handleGoBack = () => {
   
    if (window.history.length > 2) {
      navigate(-1); 
    } else {
      navigate('/'); 
    }
  };
  
if(!user.token) return

  return (
    <>
      <Paper sx={{ borderRadius: "8px", border: "1px solid #1615131a;" }}>
     <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          p={1}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
             {"Global Search"}   
          </Typography>
           {/* <Link to="/transaction-list"> */}
            <Button onClick={()=>handleGoBack()}size="small" className="backBtn">
              Go Back
            </Button>
          {/* </Link>
           */}
        </Box> 

        {/* <Box className="ExportStyle">
         <Button
                    disabled={exportLoading}
                    type="button"
                    onClick={(e) => exportData(e)}
                  >
                    {exportLoading ? "Please wait..!" : "Export"}
                  </Button>
             
          {/* <Typography>{"Total Amount:" + totalSum}</Typography> */}
        

        <Box className="filter-box1">
        <Box className="ExportStyle">
        <Button
                    disabled={exportLoading}
                    type="button"
                    onClick={() => exportData()}
                  >
                    {exportLoading ? "Please wait..!" : "Export"}
                  </Button>
             
          {/* <Typography>{"Total Amount:" + totalSum}</Typography> */}
        </Box>
          <Grid container alignItems="center">
            {/* <Grid item md={12} sm={12} xs={12}>
             { params?.slug ==="custom"  ? "" : <Grid container alignItems="center">
                <Grid item md={1} sm={1} xs={1}>
                  <Button
                    id="basic-button1"
                    sx={{ color: "black", fontWeight: "600" }}
                    aria-controls={open1 ? "basic-menu1" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open1 ? "true" : undefined}
                    onClick={handleClick1}
                  >
                    <SearchIcon /> <KeyboardArrowDownIcon />
                  </Button>

                  <Menu
                    id="basic-menu1"
                    anchorEl={anchorEl}
                    open={open1}
                    MenuListProps={{
                      "aria-labelledby": "basic-button1",
                    }}
                  >
                    {pageDetail?.title==="Bill" && <MenuItem>
                     <Box> <Checkbox
                        name="vendor"
                        checked={vendorChecked}
                        ref={vendorRef}
                        onClick={handleClose1}
                      />
                      Vendor Name
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          width: "100%",
                          position: "relative",
                          top: "-16px",
                          left: "5px",
                        }}
                      >
                        <svg
                          onClick={handleClose1}
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          height={25}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          ></path>
                        </svg>
                      </Box>
                    </MenuItem> }
                    <MenuItem>
                      <Box>
                        <Checkbox
                          name="date"
                          checked={dateChecked}
                          ref={dateRef}
                          onClick={handleClose1}
                        />
                        Date
                      </Box>
                   {  pageDetail?.title==="Bill" ?<></>:<Box
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          width: "100%",
                          position: "relative",
                          top: "-16px",
                          left: "5px",
                        }}
                      >
                        <svg
                          onClick={handleClose1}
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          height={25}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          ></path>
                        </svg>
                      </Box>}
                    </MenuItem>

                    {/* <MenuItem>
                      <Checkbox
                        name="memo"
                        checked={MemoChecked}
                        ref={MemoRef}
                        onClick={handleClose1}
                      />
                      Memo
                    </MenuItem> */}
{/* 
                    <MenuItem>
                      <Checkbox
                        name="documentno"
                        checked={docuChecked}
                        ref={docuRef}
                        onClick={handleClose1}
                      />
                      Document No.
                    </MenuItem>
                    {/* <MenuItem>
                      <Checkbox
                        name="internalid"
                        checked={idChecked}
                        ref={docuRef}
                        onClick={handleClose1}
                      />
                      View Id
                    </MenuItem> */}
                    {/* <MenuItem>
                      <Checkbox
                        name="name"
                        checked={customerChecked}
                        ref={customerRef}
                        onClick={handleClose1}
                      />
                      Name
                    </MenuItem> */}
          </Grid>
        </Box>
        <AgGridPaginatedTable
          getTableRows={getTransactionTypeDetailTableData}
          // columns={transactionTypeDetailSalesOrder}
          columns={
            globalSearch
          }
          perPage={20}
          refreshCounter={tableRefreshCount}
        //   onSortChanged={onSortChanged}
          onInputSearch={onInputSearch}
        />
      </Paper>
    </>
  );
}
